module.exports = __webpack_public_path__ + "static/media/icon_engineering.56c2a657.svg";